import { createApp } from 'vue';
import PublicCart from './PublicCart.vue';
import styles from '../../css/favorites-public.css?inline';

const mountPublicCart = (selector = '#favorites-public', dataProps = {}) => {
    const hostElement = document.querySelector(selector);
    if (!hostElement) return;

    // Read token
    const token = dataProps.token || hostElement.dataset.token;

    if (!token) {
        console.error("PublicCart: No token provided");
        return;
    }

    // Create Shadow DOM
    const shadowRoot = hostElement.attachShadow({ mode: 'open' });

    // Inject Styles
    const styleTag = document.createElement('style');
    styleTag.textContent = styles;
    shadowRoot.appendChild(styleTag);

    // Create App Container
    const appContainer = document.createElement('div');
    appContainer.id = 'public-cart-app-container';
    // Ensure height passes through
    appContainer.style.height = '100%';
    shadowRoot.appendChild(appContainer);

    const app = createApp(PublicCart, {
        token: token
    });

    app.mount(appContainer);
};

// Auto-mount if element exists
if (document.querySelector('#favorites-public')) {
    mountPublicCart('#favorites-public');
}
